
$(document).ready(function(){
    $('.form-concours').submit(function(e){


        e.preventDefault();
        var url = $('#urlConcours').val();

        var formData = {
            'nom'           : $('.concours-nom').val(),
            'prenom'        : $('.concours-prenom').val(),
            'email'         : $('.concours-email').val(),
            'telephone'     : ($('.concours-telephone').length) ? $('.concours-telephone').val() : '',
            'adresse'       : ($('.concours-adresse').length) ? $('.concours-telephone').val() : '',
            'reponses1'       : ($('.concours-reponses1').length) ? $('.concours-reponses1').val() : '',
            'reponses2'       : ($('.concours-reponses2').length) ? $('.concours-reponses2').val() : '',
            'reponses3'       : ($('.concours-reponses3').length) ? $('.concours-reponses3').val() : '',
            'reponses4'       : ($('.concours-reponses4').length) ? $('.concours-reponses4').val() : '',
            //'is_conditions' : $('.concours-is_conditions').val(),
            'concours_id'   : $('.concours-concours_id').val(),
            '_token'        : $('input[name=_token]').val()
        };

        if( $('#is_conditions').is(':checked') ){

            // Send the data using post
            var posting = $.ajax({
                url: url,
                type: "post",
                data: formData,
                dataType: 'json',
                success: function( data ) {
                    console.log('success');
                    console.log(data.responseJSON);
                    console.log(data);
                    if(data.status) {
                        $('.form-merci').html(data.merci);
                        $('.form-concours').hide();
                        $('.form-merci').show();
                    }
                },
                error: function( data ) {
                    console.log('error');
                    console.log(data.responseJSON);
                    $('.has-error').removeClass('has-error');
                    $('.help-block').remove();

                    if (data.responseJSON.nom) {
                        $('.nom-group').addClass('has-error');
                        $('.nom-group').append('<div class="help-block">' + data.responseJSON.nom + '</div>');
                    }
                    if (data.responseJSON.prenom) {
                        $('.prenom-group').addClass('has-error');
                        $('.prenom-group').append('<div class="help-block">' + data.responseJSON.prenom + '</div>');
                    }
                    if (data.responseJSON.email) {
                        $('.email-group').addClass('has-error');
                        $('.email-group').append('<div class="help-block">' + data.responseJSON.email + '</div>');
                    }

                }
            });
        } else {
            alert("Merci d'accepter les conditions générales du concours");
        }
        return false;
    });

    if (window.location.hash) {
        if (window.location.hash == "#concours") {
            $('#modalConcours').modal('show');
        }
        // Fragment exists
    } else {
        // Fragment doesn't exist
    }
});